import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import TreeRender from './TreeRender';
import { cloneDeep } from 'lodash';

interface SelectTreeProps {
  handleNodeClick?: (data: any, selected: boolean) => void;
  currentSelectNode?: any;
  data: any;
  onChange?: (data?: any) => void;
  targetIndex?: number;
  parentNode?: any;
}

const SelectTree: ForwardRefExoticComponent<PropsWithoutRef<SelectTreeProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    handleNodeClick,
    currentSelectNode,
    data,
    onChange,
  },
  ref,
) => {
  return (
    <div className={styles.tree_wrap}>
      <TreeRender
        data={data}
        currentSelectNode={currentSelectNode}
        onChange={() => {
          onChange && onChange(cloneDeep(data));
        }}
        handleNodeClick={handleNodeClick}
      />
    </div>
  );
});

export default SelectTree;
